// config/validationPolicy.js
export const userIds = new Set([
  // Hrutuja Patnekar
  // "DBfkywqzlONnWlLp38pdMHfTXwP2",

  // Emily
  "b0T48BJa2feao2Zh3PBUSMfBct83",

  // Emma
  "3vd2Ohwv8gajnFMEqInqh5NT7943",
  "ElzUEbLYKHZQmEgkn5qQHBYpEOA2",

  // Jamie
  "eK9vGxIPf3Rifqbj7uzkslIFhSl1",
  "nVDZxkrO2EUTbOlyQTCr8gBHZVG2",

  // Aditya
  "IqvwtcrFgdYidRxwenUkDvXzlPG2",
  "HICY9wxKrDc0wDFZixXAcVDxpW33",

  // Hayleigh
  "BR3vw5mDzvda7XVRD56mYihg6z13",

  // Angel
  "yYwvZ6Wel2gwzoAzzcr4lNmr31i1",
]);

export const shouldBypassValidation = (uid) => Boolean(uid && userIds.has(uid));
